export default "__VITE_PUBLIC_ASSET__ce8f7776__"